import { EventDispatcher } from "strongly-typed-events";
import { FilterChangedModel } from "../Models/FilterChangedModel";
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { MultipleFilterModel } from "../Models/MultipleFilterModel";
import { LabelFilter } from "../Models/LabelFilter";
import { WidgetType } from "../Enums/WidgetType";

export class FiltersManager {

    constructor(private containerElement: JQuery, private widgetType : WidgetType) {

    }

    public onFiltersChange = new EventDispatcher<undefined, FilterChangedModel>();

    private searchInput : JQuery<HTMLElement>;

    private searchClearButton : JQuery<HTMLElement>;
    private searchButton : JQuery<HTMLElement>;

    private filtersLabelContainer : JQuery<HTMLElement>;

    private selectedLabelsContainer : JQuery<HTMLElement>;
    private clearAllSelectedFiltersButton : JQuery<HTMLElement>;
    private mobileClearSelectedFiltersButton : JQuery<HTMLElement>;

    private mobileAmountOfItemsLabel : JQuery<HTMLElement>;

    private selectedLabelTemplate : JQuery<HTMLElement>;

    private hasTouchScreen : boolean; 

    private labelsForBlock : LabelFilter[];

    public initialize() {
        this.labelsForBlock = [];
        this.hasTouchScreen = false;

        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            this.hasTouchScreen = true;
        }

        this.bindElements();
        this.bindEvents();

        this.initializeUrlFilters();
    }

    private bindElements() {
        var self = this;

        this.searchInput = this.containerElement.find('.filter-searchbar-input');

        this.searchClearButton = this.containerElement.find('.filter-searchbar-clear-btn');
        this.searchButton = this.containerElement.find('.filter-searchbar-search-btn');

        this.filtersLabelContainer = this.containerElement.find('.filter-labels-container');

        this.selectedLabelsContainer = this.containerElement.find('.filter-selected-labels-container');
        this.clearAllSelectedFiltersButton = this.containerElement.find('#clear-all-selected-filters-button');
        this.mobileClearSelectedFiltersButton = this.containerElement.find('button[data-clear-button]');

        this.selectedLabelTemplate = this.containerElement.find('#selected-label-template');

        this.mobileAmountOfItemsLabel = this.containerElement.find('#mobile-view-amount-of-item');

        var windowHeight = $(window).height();

        var mobileChildFiltersBackdrop = this.containerElement.find('#mobile-child-filters-backdrop');
        var mobileChildFilters = this.containerElement.find('#mobile-child-filters');

        var body = $('body');

        if(!this.hasTouchScreen) {
            mobileChildFiltersBackdrop.remove();
            mobileChildFilters.remove();
        }

        $(window).click((e) => {
            var target = $(e.target);
            if(!target.hasClass('child-filters') && target.parents('.child-filters').length == 0) {
                var activeFilter = self.filtersLabelContainer.find('button.multiple-filter-label-button.show');
                activeFilter?.trigger('click');
            }
        });

        this.filtersLabelContainer.find('button.multiple-filter-label-button').each((index, element) => {
            var multipleFilter = $(element);
            var parentContainer = multipleFilter.parent();
            var childContainer = parentContainer.find('.child-filters');
            var multipleFilterId = multipleFilter.data('multiple-label-filter-id');
            var mobileFiltedAccordionItemContainer = mobileChildFilters.find(`div[data-target="#mfcontainer-${multipleFilterId}"]`);

            if(this.hasTouchScreen) {
                childContainer.remove();
            }

            multipleFilter.on('click', (e) => {    
                e.stopPropagation();
                
                if(multipleFilter.hasClass('show')) {
                    mobileChildFilters.animate({
                        bottom: '-1200px'
                    }, 500);
                    mobileChildFiltersBackdrop.animate({
                        opacity: '0'
                    }, 250);

                    multipleFilter.removeClass('show');
                    setTimeout(() => {
                        body.removeClass('child-filters-shown');
                    }, 50)
                    
                    if (this.hasTouchScreen) {
                        setTimeout(() => {
                            parentContainer.removeClass('show');
                            mobileChildFilters.removeClass('show');
                        }, 500)
                    }
                    else {
                        parentContainer.removeClass('show');
                    }
                }
                else {
                    var activeFilter = this.filtersLabelContainer.find('button.multiple-filter-label-button.show');
                    if(activeFilter != undefined && activeFilter.length >= 1) {
                        activeFilter.removeClass('show');
                        activeFilter.parent().removeClass('show');
                    }

                    multipleFilter.addClass('show');
                    parentContainer.addClass('show');
                    mobileChildFilters.addClass('show');
                    setTimeout(() => {
                        body.addClass('child-filters-shown');
                    }, 450)
                    
                    mobileChildFilters.animate({
                        bottom: '0px'
                    }, 500);

                    if(mobileFiltedAccordionItemContainer.hasClass('collapsed')) {
                        mobileFiltedAccordionItemContainer.trigger('click');
                    }

                    mobileChildFilters.animate({
                        bottom: '0px'
                    }, 500);
                    mobileChildFiltersBackdrop.animate({
                        opacity: '1'
                    }, 500);

                    if (!this.hasTouchScreen) {
                        var offsetTop = childContainer.offset()?.top;
                        var scrollTop = $(document).scrollTop();
    
                        if(offsetTop != undefined && windowHeight != undefined && scrollTop != undefined) {
                            var maxHeight = (windowHeight - (offsetTop - scrollTop));
                            childContainer.css('max-height', `${Math.round(maxHeight) - 5}px`);
                        }
                    }
                }
            })
        });

        this.filtersLabelContainer.find('.child-filters-close-bar-close-button').on('click', (e) => {
            e.stopPropagation();

            var activeFilter = this.filtersLabelContainer.find('button.multiple-filter-label-button.show');
            activeFilter.trigger('click');
        });

        this.filtersLabelContainer.find('button[data-view-items]').on('click', (e) => {
            e.stopPropagation();

            var activeFilter = this.filtersLabelContainer.find('button.multiple-filter-label-button.show');
            activeFilter.trigger('click');
        });
    }

    private bindEvents() {
        this.bindSearchEvents();

        this.bindLabelsEvents()
    }

    private bindSearchEvents() {
        var self = this;

        self.searchInput.on('input', () => {
            var searchInputValue = this.searchInput.val()?.toString();
            if(searchInputValue == undefined || searchInputValue.length == 0) {
                self.searchClearButton.css('visibility', "hidden");
            }
            else {
                self.searchClearButton.css('visibility', "visible");   
            }
        });

        self.searchInput.on('keyup', function (e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                self.onFiltersChange.dispatch(undefined, self.getFilters());
                self.searchInput.trigger('blur');
            }
        });

        self.searchClearButton.on('click', (e) => {
            e.stopPropagation();

            self.searchInput.val("");
            self.searchClearButton.css('visibility', "hidden");

            self.onFiltersChange.dispatch(undefined, self.getFilters());
        });

        self.searchButton.on('click', (e) => {
            e.stopPropagation();

            self.onFiltersChange.dispatch(undefined, self.getFilters());
        });
    }

    private bindLabelsEvents() {
        var self = this;
        if(self.filtersLabelContainer.hasClass('filter-labels-container-slider')) {
            var swipedNextButton = self.filtersLabelContainer.find('.swiper-button-next');

            const createdSwiper = new Swiper('.multiple-filters-swiper', {
                slidesPerView: 'auto',
                freeMode: true,
                freeModeSticky: true,
                navigation: {
                    nextEl: '.swiper-button-next'
                },
                on: {
                    sliderMove(swiper, event) {
                        if(swiper.touches.diff < 0) {
                            swipedNextButton.remove();
                            swiper.off('sliderMove');
                        }
                    },
                }
            });
        }

        self.containerElement.find('div.child-filter-item').each((index, checkboxContainer) => {
            var container = $(checkboxContainer);
            var containerCheckbox = container.find('input[type="checkbox"]');

            var labelFilter = new LabelFilter();
            labelFilter.id = container.data('child-label-filter-id');
            labelFilter.name = container.find('div.child-filter-item-name').text();
            labelFilter.amountOfItemsForLabel = -1;
            self.labelsForBlock.push(labelFilter);

            containerCheckbox.on('click', (e) => {
                e.preventDefault();
                e.stopImmediatePropagation();
            })

            container.find('.row').on('click', (e) => {
                if(!containerCheckbox.parent().hasClass('disabled-checkbox')) {
                    var isChecked = containerCheckbox.is('checked');
                    containerCheckbox.prop('checked', !isChecked);
                    containerCheckbox.trigger('change');
                }
            });
        });

        self.containerElement.find('input[data-simple-label-filter-id]').each((index, checkboxContainer) => {
            var simpleCheckbox = $(checkboxContainer);

            var labelFilter = new LabelFilter();
            labelFilter.id = simpleCheckbox.data('simple-label-filter-id');
            labelFilter.name = simpleCheckbox.parent().text().trim();
            labelFilter.amountOfItemsForLabel = -1;
            self.labelsForBlock.push(labelFilter);

        });

        var selectedAmountOfFilters = 0;
        var filterSelectionTimer;
        self.containerElement.find('input[type="checkbox"]').each((index, checkboxElement) => {
            var filterItemCheckbox = $(checkboxElement);

            var name;
            if(filterItemCheckbox.data('simple-label-filter-id') !== undefined) {
                name = filterItemCheckbox.parent().text().trim();
            }
            else {
                name = filterItemCheckbox.closest('.child-filter-item').find('.child-filter-item-name').text();
            }
            
            var id = filterItemCheckbox.attr('id');
            
            var selectedLabelTemplateItem : JQuery<HTMLElement> | undefined;

            var removeSelectedLabelItem = () => {
                if(selectedLabelTemplateItem != undefined) {
                    selectedLabelTemplateItem.remove();
                    selectedLabelTemplateItem = undefined;
                    filterItemCheckbox.prop('checked', false);
                    selectedAmountOfFilters--;

                    if(selectedAmountOfFilters <= 0) {
                        self.clearAllSelectedFiltersButton.addClass('d-none');
                        self.mobileClearSelectedFiltersButton.prop('disabled', true);
                    }

                    if(self.hasTouchScreen) {
                        self.updateAccordionHeaders();
                    }
                }
            }

            var preSelectedLabel = self.containerElement.find(`label[data-pre-selected-label="${id}"]`);
            if(preSelectedLabel != undefined && preSelectedLabel.length >= 1) {
                selectedLabelTemplateItem = preSelectedLabel;
                selectedAmountOfFilters++;

                selectedLabelTemplateItem.on('click', () => {
                    removeSelectedLabelItem();
                    self.onFiltersChange.dispatch(undefined, self.getFilters());
                });
            }

            filterItemCheckbox.on('change', (e, shouldUpdateUrl : boolean | undefined) => {
                if(selectedLabelTemplateItem == undefined && self.selectedLabelTemplate != undefined && self.selectedLabelTemplate.length >= 1) {
                    selectedLabelTemplateItem = $(self.selectedLabelTemplate.html());

                    selectedLabelTemplateItem.find('#selected-label-name').html(`${name} <i class="fas fa-times"></i>`);
                    self.selectedLabelsContainer.prepend(selectedLabelTemplateItem);
                    selectedAmountOfFilters++;
                    
                    selectedLabelTemplateItem.on('click', () => {
                        removeSelectedLabelItem();
                        self.onFiltersChange.dispatch(undefined, self.getFilters());
                    });
                }
                else {
                    removeSelectedLabelItem();
                }

                if(shouldUpdateUrl == undefined || shouldUpdateUrl == true) {
                    if(filterItemCheckbox.is(':checked')) {
                        self.updateUrl(name, name, undefined);
                    }
                    else {
                        self.updateUrl(name, undefined, name);
                    }
                }

                clearTimeout(filterSelectionTimer);
                filterSelectionTimer = setTimeout(function() {
                    self.onFiltersChange.dispatch(undefined, self.getFilters());
                }, 50);

                if(selectedAmountOfFilters > 1) {
                    self.clearAllSelectedFiltersButton.removeClass('d-none');
                    self.mobileClearSelectedFiltersButton.prop('disabled', false);
                }

                if(self.hasTouchScreen) {
                    self.updateAccordionHeaders();
                }
                
            });
        })

        self.mobileClearSelectedFiltersButton.on('click', (e) => {
            e.stopPropagation();

            self.clearAllSelectedFiltersButton.trigger('click');
        })

        self.clearAllSelectedFiltersButton.on('click', (e) => {
            e.stopPropagation();

            self.clearAllSelectedFiltersButton.addClass('d-none');
            self.selectedLabelsContainer.find('.filter-label-button:not(.d-none)').remove();
            self.filtersLabelContainer.find('input:checked').prop('checked', false).trigger('change');
        })
    }

    private updateAccordionHeaders() {
        this.filtersLabelContainer.find('.accordion-label-header').each((index, headerelement) => {
            var accordionHeader = $(headerelement);
            var target : string = accordionHeader.data('target');
            target = target.replace('#mfcontainer-', '');

            var targetButton = this.filtersLabelContainer.find(`button[data-multiple-label-filter-id="${target}"]`);

            if(accordionHeader.parent().find('input:checked').length > 0) {
                targetButton.addClass('child-label-selected');
            }
            else {
                targetButton.removeClass('child-label-selected');
            }
        });
    }

    
    public getFilters() : FilterChangedModel {
        var self = this;
        var result = new FilterChangedModel();

        var searchInputValue = this.searchInput.val()?.toString();
        if(searchInputValue != undefined) {
            result.searchString = searchInputValue;
        }

        var simpleFilters : string[] = [];
        this.containerElement.find('input[data-simple-label-filter-id]:checked').each((index, element) => {
            simpleFilters.push($(element).data('simple-label-filter-id'));
        });

        result.simpleFilters = simpleFilters;

        var findMultipleFiltersWithinElement = (parentElement : JQuery<HTMLElement>) : string[] => {
            var multipleFilters : string[] = [];

            parentElement.find('input:checked').each((index, element) => {
                var childFilterId = $(element).attr('id');
                if(childFilterId != undefined) {
                    multipleFilters.push(childFilterId);
                }
            });

            return multipleFilters;
        }

        result.multipleFilters = [];
        this.containerElement.find('button[data-multiple-label-filter-id]').each((index, element) => {
            var multipleFilterModel = new MultipleFilterModel();

            var multipleFiltersElement = $(element);
            multipleFilterModel.multipleFilterId = multipleFiltersElement.data('multiple-label-filter-id');

            if(self.hasTouchScreen) {
                multipleFilterModel.selectedFilters = findMultipleFiltersWithinElement($(`#mf-${multipleFilterModel.multipleFilterId}`));
            }
            else {
                multipleFilterModel.selectedFilters = findMultipleFiltersWithinElement(multipleFiltersElement.parent());
            }

            if(multipleFilterModel.selectedFilters.length >= 1) {
                result.multipleFilters.push(multipleFilterModel);
            }
        });

        return result;
    }

    public setFiltersCount(totalNumberOfItems : number, labelFilters : LabelFilter[]) {
        this.mobileAmountOfItemsLabel.text(totalNumberOfItems);

        if(labelFilters != undefined && labelFilters.length >= 1) {
            labelFilters.forEach((childLabel, index) => {
                var childLabelItem = this.containerElement.find(`div[data-child-label-filter-id="${childLabel.id}"]`);

                childLabelItem.find('.child-filter-item-items-count').find('label').text(childLabel.amountOfItemsForLabel);

                var checkboxContainer = childLabelItem.find('.large-checkbox');
                if(childLabel.amountOfItemsForLabel == 0) {
                    checkboxContainer.addClass('disabled-checkbox');
                }
                else {
                    checkboxContainer.removeClass('disabled-checkbox');
                }
            })
        }
    }

    //#region URL stuff

    private initializeUrlFilters() {
        var self = this;
        var url = new URL(location.href);
        var searchParamName = `${self.widgetType.toString().replace('Widget', '').toLowerCase()}Labels`
        var labelsParameter = url.searchParams.get(searchParamName);

        if(labelsParameter != undefined && labelsParameter != null && labelsParameter.length > 0 && self.labelsForBlock != undefined && self.labelsForBlock.length > 0) {
            var splittedLabels = decodeURIComponent(labelsParameter).split('|');
            if(splittedLabels != undefined && splittedLabels.length > 0) {
                splittedLabels.forEach((label, index) => {
                    var foundExistingLabel = self.labelsForBlock.find(x => x.name == label);

                    if(foundExistingLabel != undefined) {
                        var existingLabelCheckbox = self.containerElement.find(`#${foundExistingLabel.id}`);
                        if(existingLabelCheckbox == undefined || existingLabelCheckbox.length == 0) {
                            existingLabelCheckbox = self.containerElement.find(`input[data-simple-label-filter-id="${foundExistingLabel.id}"]`);
                        }
                        existingLabelCheckbox.prop('checked', true);
                        existingLabelCheckbox.trigger('change', [false]);
                    }
                })
            }
        }
    }

    private updateUrl = (labelName: string, addedItem : string | undefined, removedItem : string | undefined) => {
        var self = this;
        var url = new URL(location.href);
        var searchParamName = `${self.widgetType.toString().replace('Widget', '').toLowerCase()}Labels`

        var labelsParameter = url.searchParams.get(searchParamName);

        var nameToUse = encodeURIComponent(labelName);

        if(addedItem != undefined) {
            if(labelsParameter == null) {
                url.searchParams.append(searchParamName, nameToUse);
            }
            else {
                labelsParameter += `|${nameToUse}`
                url.searchParams.set(searchParamName, labelsParameter);
            }
        }
        else if(removedItem != undefined) {
            if(labelsParameter != null) {
                if(labelsParameter.indexOf(`|${nameToUse}`) >= 0) {
                    labelsParameter = labelsParameter.replace(`|${nameToUse}`, '');
                } 
                else if(labelsParameter.indexOf(`${nameToUse}`) >= 0) {

                    if(labelsParameter.indexOf(`${nameToUse}|`) >= 0) {
                        labelsParameter = labelsParameter.replace(`${nameToUse}|`, '');
                    }
                    else {
                        labelsParameter = labelsParameter.replace(`${nameToUse}`, '');
                    }
                }

                if(labelsParameter.length <= 0) {
                    url.searchParams.delete(searchParamName);
                }
                else {
                    url.searchParams.set(searchParamName, labelsParameter);
                } 
            }
        }

        window.history.replaceState(null, '', url.toString())
    }

    //#endregion
}